import {
    apiRequest,
    riwayatpenugasanList,
    riwayatpenugasanActive,
    riwayatpenugasanInactive
} from "../../../../../services/adapters/kepegawaian/riwayatpenugasanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatpenugasanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", riwayatpenugasanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", riwayatpenugasanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository